import React, { useEffect, useState } from "react";
import { EuiDatePicker, EuiFormRow } from "@elastic/eui";
import _ from "lodash";
import moment from "moment";
import { Controller } from "react-hook-form";
import * as localStorage from "../../../../../../lib/localStorage";

const locale = localStorage.getItem("locale");
const timeInterval = 15; // minutes

function AbstractDate({ options, errors, entityObject, control, onDateChange }) {
    const selectedValue = entityObject && entityObject[options.name];
    const selectedDate =
        selectedValue && typeof entityObject[options.name] === "string"
            ? moment(selectedValue)
            : selectedValue;

    const [startDate, setStartDate] = useState(selectedDate || null);

    const handleChange = (date) => {
        setStartDate(date);
        onDateChange && onDateChange(date);
    };

    useEffect(() => {
        setStartDate(selectedDate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [entityObject, options.name, selectedValue]);

    return (
        <EuiFormRow
            label={options.label}
            id={options.name}
            key={options.name}
            isInvalid={!_.isNil(errors[options.name])}
            error={options.errorMessage}
            fullWidth
        >
            <Controller
                control={control}
                defaultValue={startDate}
                name={options.name}
                id={options.name}
                rules={{ ...options.validation }}
                render={({ onChange, value, ref }) => (
                    <EuiDatePicker
                        timeIntervals={timeInterval}
                        showTimeSelect
                        name={options.name}
                        id={options.name}
                        isInvalid={!!errors && !!errors[options.name]}
                        selected={startDate || null}
                        onChange={(e) => {
                            handleChange(e);
                            onChange(e);
                        }}
                        onClear={() => {
                            handleChange(null);
                            onChange(null);
                        }}
                        placeholder="Choose date"
                        fullWidth
                        locale={locale || "en"}
                        timeFormat="HH:mm"
                        dateFormat="DD/MM/YYYY HH:mm"
                    />
                )}
            />
        </EuiFormRow>
    );
}

export default AbstractDate;
